<template>
    <div id="app">外部边框
    </div>
</template>

<script>

export default {
    name: 'frame_box',
    components: {
    }
}
</script>

<style>
</style>
